import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";

const AddBankInfoPage = () => {
    const { id: businessId } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        bankName: "",
        routingNo: "",
        accountNo: "",
        checkNo: ""
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await api.put(`/business/${businessId}/set-bank-data`, formData);
            alert("Bank info updated successfully.");
            navigate(`/dashboard/business/${businessId}`);
        } catch (error) {
            console.error("Error updating bank info:", error);
            alert("Failed to update bank information. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="add-bank-page">
            <h2>Add Bank Account Information</h2>
            <form className="add-bank-form" onSubmit={handleSubmit}>
                <div>
                    <label>Bank Name:</label>
                    <input
                        type="text"
                        name="bankName"
                        value={formData.bankName}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label>Routing Number:</label>
                    <input
                        type="text"
                        name="routingNo"
                        value={formData.routingNo}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label>Account Number:</label>
                    <input
                        type="text"
                        name="accountNo"
                        value={formData.accountNo}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label>Check Number:</label>
                    <input
                        type="text"
                        name="checkNo"
                        value={formData.checkNo}
                        onChange={handleChange}
                        required
                    />
                </div>

                <button className="add-bank-btn" type="submit" disabled={loading}>
                    {loading ? "Updating..." : "Submit"}
                </button>
                <button className="add-bank-cancel" type="button" onClick={() => navigate(-1)}>
                    Cancel
                </button>
            </form>
        </div>
    );
};

export default AddBankInfoPage;
